'use client';

import { useEffect, useState } from 'react';

export function ConditionalFooter({ children }: { children: React.ReactNode }) {
  const [isSubdomain, setIsSubdomain] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const hostname = window.location.hostname;
    const isNotesSubdomain = hostname.startsWith('notes.') ||
      hostname.includes('.notes.') ||
      (hostname.includes('localhost') && window.location.pathname.startsWith('/notes'));
    const isAuthSubdomain = hostname.startsWith('auth.') ||
      hostname.includes('.auth.') ||
      (hostname.includes('localhost') && window.location.pathname.startsWith('/auth'));
    const isLearnSubdomain = hostname.startsWith('learn.') ||
      hostname.includes('.learn.') ||
      (hostname.includes('localhost') && window.location.pathname.startsWith('/learn'));

    setIsSubdomain(isNotesSubdomain || isAuthSubdomain || isLearnSubdomain);
    setIsLoading(false);
  }, []);

  if (isLoading || isSubdomain) {
    return null;
  }

  return <>{children}</>;
}
